export default __webpack_public_path__ + "static/media/icon_drag.c13c76a7.svg";